
const CloseIcon = (props) => {
    const { onClick } = props;
    return (
        <svg onClick={onClick || false} xmlns="http://www.w3.org/2000/svg" width="15.127" height="15.127" viewBox="0 0 15.127 15.127">
            <path d="m2 2 12.3 12.3m0-12.3L2 14.3" transform="translate(-.586 -.586)" fill="none" stroke="#000" fillRule="evenodd" strokeLinecap="round" strokeWidth="2px"
            />
        </svg>
    )
};

export default CloseIcon